/* unplugin-vue-components disabled */import script from "./InvoiceDownstreamAllocationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceDownstreamAllocationDialog.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceDownstreamAllocationDialog.vue?vue&type=style&index=0&id=a93a7b46&scoped=true&lang=css"
import "./InvoiceDownstreamAllocationDialog.vue?vue&type=style&index=1&id=a93a7b46&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a93a7b46"]])

export default __exports__